<div *ngIf="pollData" [class.smallPollContainer]="small" class="pollContainer">
    <div class="d-flex gap-10 align-items-start">
        <div>
            <h3 class="my-0">{{ pollData.text }}</h3>
            <div class="italic">{{ pollData.description }}</div>
        </div>
    </div>
    <ng-container *ngIf="pollData.scale && !showResult">
        <ng-container *ngFor="let question of pollData.questions; let index = i">
            <ng-container [ngTemplateOutletContext]="{question:question}"
                          [ngTemplateOutlet]="questionContent"></ng-container>
        </ng-container>

        <div *ngIf="!hasTimePassed && !preview && (hasCommunityRole(['member']) || this.hasCommunityRole(['full_admin']))"
             class="my-20 d-flex flex-space-between align-items-end gap-5">
            <div><span *ngIf="pollData.end_at"
                       class="textAccent">* The poll will close {{ pollData.end_at | relativeTime }}</span>
            </div>
            <button (click)="vote()" *ngIf="!showResult" [disabled]="!pollVoteValid || voteSending"
                    color="accent" mat-raised-button>
                Vote
                <mat-icon *ngIf="voteSending">
                    <mat-spinner color="accent"></mat-spinner>
                </mat-icon>
            </button>
            <!--            <button *ngIf="showResult" mat-raised-button color="accent" (click)="changeVote()">Change vote-->
            <!--            </button>-->
        </div>
    </ng-container>


    <ng-container *ngIf="!pollData.scale || showResult">


        <div [class.mt-10]="small" [class.mt-20]="!small">

            <mat-stepper #stepper (stepsChanged)="updateSteps($event)"
                         [class.hideheader]="pollData.questions?.length <=1 "
                         [linear]="!showResult" appStepperWatcher
                         class="pollStepper" [class.tickIcon]="showResult">
                <ng-container>
                    <ng-container *ngFor="let question of pollData.questions; let index = i">
                        <!--                        [label]="question.text"-->
                        <mat-step *ngIf="displayConditionsMet(question)">
                            <ng-container [ngTemplateOutletContext]="{question:question}"
                                          [ngTemplateOutlet]="questionContent"></ng-container>
                        </mat-step>
                    </ng-container>
                </ng-container>
            </mat-stepper>


        </div>
        <div *ngIf="!hasTimePassed && !preview && (hasCommunityRole(['member']) || this.hasCommunityRole(['full_admin']))"
             class="my-20 d-flex flex-space-between align-items-end gap-5">
            <div><span *ngIf="pollData.end_at"
                       class="textAccent">* The poll will be closed {{ pollData.end_at | relativeTime }}</span>
            </div>
            <button (click)="stepper.next()" *ngIf="!showResult && steps > 1 && steps !== stepper.selectedIndex + 1"
                    [disabled]="!questionPollVoteValid(getQuestion(stepper.selectedIndex))"
                    color="accent" mat-raised-button>
                Next question
            </button>
            <button (click)="vote()" *ngIf="!showResult && steps === stepper.selectedIndex + 1"
                    [disabled]="steps !== pollData.questions?.length ? !questionPollVoteValid(getQuestion(stepper.selectedIndex)) : !pollVoteValid"
                    color="accent"
                    mat-raised-button>
                Vote
            </button>
            <!--            <button *ngIf="showResult" mat-raised-button color="accent" (click)="changeVote()">Change vote-->
            <!--            </button>-->
        </div>
    </ng-container>

</div>

<ng-template #questionContent let-question="question">
    <h3>{{ question.text }}</h3>
    <h5 *ngIf="question.description">{{ question.description }}</h5>
    <ng-container *ngIf="question.type == 'order'">
        <ng-container [ngTemplateOutletContext]="{question}"
                      [ngTemplateOutlet]="dragDrop"></ng-container>
    </ng-container>
    <ng-container *ngIf="question.type == 'lists'">
        <ng-container [ngTemplateOutletContext]="{question}"
                      [ngTemplateOutlet]="listDragDrop"></ng-container>
    </ng-container>
    <ng-container *ngIf="question.type == 'slider'">
        <ng-container [ngTemplateOutletContext]="{question}"
                      [ngTemplateOutlet]="sliders"></ng-container>
    </ng-container>
    <ng-container *ngIf="question.type == 'click_game' && !showResult">
        <ng-container [ngTemplateOutletContext]="{question}"
                      [ngTemplateOutlet]="clickGame"></ng-container>
    </ng-container>
    <ng-container *ngIf="question.type == 'select' || (question.type == 'click_game' && showResult)">
        <div [class.flex-row]="pollData.scale && !showResult"
             [class.flex-space-around]="pollData.scale && !showResult" [class.gap-10]="pollData.scale">
            <div *ngFor="let option of question.options" [class.flex-even]="pollData.scale" [class.mb-10]="small"
                 [class.mb-15]="!small"
                 [ngStyle]="{ width: pollData.scale && !showResult ? 'calc(100%/' + question.options.length + ')' : '' }"
                 class="flex-col gap-5" data-test="calc(100%/' + question.options.length + ');'">
                <ng-container [ngTemplateOutletContext]="{option, question}"
                              [ngTemplateOutlet]="question.multiple_choices ? multipleChoice : singleChoice"></ng-container>
            </div>
            <small *ngIf="question.max_responses && question?.results?.length >= question.max_responses && !preview && !showResult">
                You can only select {{ question.max_responses }} options. Unselect an option to select another.
            </small>
        </div>
    </ng-container>
</ng-template>
<ng-template #multipleChoice let-option="option" let-question="question">
    <div class="flex-row gap-10">
        <div class="voteBlock">
            <div *ngIf="showResult"
                 class="percentage">{{ getPercentage(option.votes_count, this.pollData.total_votes) }}
                <br>({{ option.votes_count }} Votes)
            </div>

            <mat-checkbox #opt (change)="setResult(question, 'results', option,true)"
                          [checked]="question.results?.includes(option.id)" [disableRipple]="true"
                          [disabled]="preview || ((question.max_responses && question?.results?.length >= question.max_responses) && !question.results?.includes(option.id))"
                          [hidden]="showResult"
                          [value]="option.id"
                          color="accent">
            </mat-checkbox>

        </div>
        <div (click)="!showResult && opt._onInputClick()" [class.cursorPointer]="!showResult"
             [class.mt-5]="small" [class.showResult]="showResult"
             class="flex-col w-100 option-detail justify-content-center">
            <ng-container [ngTemplateOutletContext]="{
                              count:option.votes_count,
                              text: option.text,
                              description:option.description,
                              checked: question.results?.includes(option.id),
                              showResult,
                              userVoted: pollData.user_vote.includes(option.id)
                          }"
                          [ngTemplateOutlet]="resultBar"></ng-container>
        </div>
    </div>
    <ng-container *ngIf="(question.results?.includes(option.id)|| showResult) && option.nested_options.length > 0"
                  [ngTemplateOutletContext]="{option}"
                  [ngTemplateOutlet]="nestedOptions">
    </ng-container>
</ng-template>

<ng-template #singleChoice let-option="option" let-question="question">
    <div [ngClass]="pollData.scale && !showResult? 'flex-reverse-col': 'flex-row gap-10'">
        <div class="voteBlock">
            <mat-radio-button #opt (change)="setResult(question, 'results',option,false)"
                              [checked]="question.results?.includes(option.id)"
                              [disableRipple]="true"
                              [disabled]="preview"
                              [hidden]="showResult"
                              [name]="'nestedPollOption-' + question.id" [value]="option.id"
                              color="accent">
            </mat-radio-button>

        </div>
        <div (click)="!showResult && opt._inputElement.nativeElement.click()" [class.cursorPointer]="!showResult"
             [class.flex-col]="pollData.scale" [class.mt-5]="small"
             [class.showResult]="showResult" [class.text-center]="pollData.scale && !showResult"
             class="flex-col w-100 option-detail justify-content-center">
            <ng-container [ngTemplateOutletContext]="{
                              count:option.votes_count,
                              text: option.text,
                              description:option.description,
                              checked: question.results?.includes(option.id),
                              showResult,
                              userVoted: pollData.user_vote.includes(option.id)
                          }"
                          [ngTemplateOutlet]="resultBar"></ng-container>
        </div>
    </div>
    <ng-container *ngIf="(question.results?.includes(option.id)|| showResult) &&  option.nested_options.length> 0"
                  [ngTemplateOutletContext]="{option}"
                  [ngTemplateOutlet]="nestedOptions">
    </ng-container>
</ng-template>

<ng-template #resultBar let-checked="checked" let-count="count" let-description="description"
             let-showResult="showResult"
             let-text="text" let-userVoted="userVoted">
    <div [class.checked]="checked" [class.showResult]="showResult" [class.userVoted]="userVoted" class="bar-container">
        <div [@barWidthAnimation]="{value: '*', params: {width: showResult ? getPercentage(count|| 0, this.pollData.total_votes) : '0%'}}"
             class="bar"></div>
        <div class="vote-details">
            <div [appTruncatedTooltip]="text">{{ text }}</div>
            <div *ngIf="description" [appTruncatedTooltip]="description" class="italic description">{{ description }}
            </div>
        </div>
        <div *ngIf="showResult" class="percentage">{{ getPercentage(count, this.pollData.total_votes) }}
            (<span [countUp]="count" [duration]="500"> {{ count }} </span>&nbsp;votes)
        </div>
    </div>
</ng-template>

<ng-template #nestedOptions let-option="option">
    <div class="ml-20 my-10 gap-5 flex-col">
        <h4 class="m-0">{{ option.nested_question_title }}</h4>
        <ng-container *ngFor="let nestedOption of option.nested_options ">
            <app-nested-option
                #optionComponent
                (setResult)="setResult(option, 'nestedResults', nestedOption,$event)"
                [nestedOption]="nestedOption"
                [option]="option"
                [preview]="preview"
                [showResult]="showResult"
            >
                <div (click)="!showResult && optionComponent.click()" [class.cursorPointer]="!showResult"
                     [class.mt-5]="small" [class.showResult]="showResult"
                     class="flex-col w-100 option-detail justify-content-center">
                    <ng-container [ngTemplateOutletContext]="{
                                      count:nestedOption.votes_count,
                                      text: nestedOption.text,
                                      description:nestedOption.description,
                                      checked: option?.nestedResults?.includes(nestedOption.id),
                                      showResult,
                                      userVoted: pollData.user_vote.includes(nestedOption.id)
                                  }"
                                  [ngTemplateOutlet]="resultBar"></ng-container>
                </div>
            </app-nested-option>
        </ng-container>
        <small *ngIf="option.max_nested_responses && option.nested_multiple_choices && option?.nestedResults?.length >= option.max_nested_responses && !preview && !showResult">
            You can only select {{ option.max_nested_responses }} options. Unselect an option to select another.
        </small>
    </div>
</ng-template>

<ng-template #sliders let-question="question">
    <div class="flex-col gap-10">
        <div *ngFor="let option of question.options">
            <div class="flex-col">
                <p class="m-0">{{ option.text }}</p>
                <p class="m-0" *ngIf="option.description">{{ option.description }}</p>
            </div>
            <ng-container *ngIf="showResult">
                <div class="bar-container userVoted checked showResult">
                    <div [@barWidthAnimation]="{value: '*', params: {width: getPercentage(option.average_slider_response, option.slider_max)}}"
                         class="bar"></div>
                    <div class="vote-details">
                        <div [appTruncatedTooltip]="option.text">{{ option.text }}</div>
                        <div *ngIf="option.description" [appTruncatedTooltip]="option.description"
                             class="italic description">{{ option.description }}
                        </div>
                    </div>
                    <div class="percentage">Average value {{ option.average_slider_response }}/{{ option.slider_max }}
                        (You voted {{ option.user_slider_response }})
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!showResult">
                <div class="d-flex flex-row flex-space-between gap-10">
                    <strong>{{ option.slider_start_label || '' }}</strong>
                    <strong>{{ option.slider_middle_label || '' }}</strong>
                    <strong>{{ option.slider_end_label || '' }}</strong>
                </div>
                <div class="px-20">
                    <mat-slider class="w-100" [min]="option.slider_min|| 0" [step]="option.slider_step || 1"
                                [max]="option.slider_max|| 100" showTickMarks discrete disableRipple
                                [displayWith]="option.slider_step == 0.1 ?currencySliderFormat: defaultSliderFormat">
                        <input matSliderThumb (valueChange)="setSliderValue(option, $event)">
                    </mat-slider>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #clickGame let-question="question">
    <div *ngIf="!question.start" class="d-flex flex-row justify-content-center">
        <button color="accent" mat-raised-button (click)="question.start = true">Start Game
        </button>
    </div>

    <div class="clickGameContainer" #clickContainer
         *ngIf="question.start && !question.end" [class.h-fit]="question.disable_animation">
        <ng-container *ngFor="let option of question.options; let i = index">
            <app-clickable-shape [shape]="option.shape"
                                 [class.animationPaused]="question.paused"
                                 [class.clickGameAnimation]="!question.disable_animation"
                                 [style.--size]="option.size|| 1"
                                 [style.width]="calculateSVGWidth(question.options.length, clickContainer) + 'px'"
                                 [svgWidth]="calculateSVGWidth(question.options.length, clickContainer)"
                                 [clickCount]="option.click_amount"
                                 [shadowsDisabled]="option.disable_shadows"
                                 [textBackgroundDisabled]="option.disable_text_background"
                                 [style.order]="option.order"
                                 [color]="option.colour|| community?.accent_color_hex || '#ffe1aa'"
                                 [text]="option.text"
                                 (selectOption)="setClickResult(question, 'results',option, question.multiple_choices)"
                                 (pauseAnimation)="pauseAnimation(question)"
                                 (clicked)="clickOption(option)"
                                 (animationiteration)="setRandomValuesForClickGame()"
                                 [popText]="option.description"></app-clickable-shape>
        </ng-container>
    </div>
    <div *ngIf="question.end" class="d-flex flex-col align-items-center">
        <h3 [innerHTML]="question.end"></h3>
        <div>
            <button color="accent" mat-raised-button (click)="restartGame(question)">Restart Game?</button>
        </div>
    </div>
</ng-template>

<ng-template #dragDrop let-question="question">
    <ng-container *ngIf="showResult">
        <div class="flex-col gap-10">
            <p class="m-0">Average Order:</p>
            <div class="bar-container userVoted checked showResult"
                 *ngFor="let option of orderOptions(question.options, 'average_order' )">
                <div [@barWidthAnimation]="{value: '*', params: {width: '100%'}}"
                     class="bar"></div>
                <div class="vote-details">
                    <div [appTruncatedTooltip]="option.text">{{ option.text }}</div>
                    <div *ngIf="option.description" [appTruncatedTooltip]="option.description"
                         class="italic description">{{ option.description }}
                    </div>
                </div>
                <div class="percentage"> (<span [countUp]="option.votes_count"
                                                [duration]="500"> {{ option.votes_count }} </span>&nbsp;votes)
                </div>
            </div>
        </div>
        <div class="flex-col gap-10 mt-15">
            <p class="m-0">Your Order:</p>
            <div class="bar-container userVoted checked showResult"
                 *ngFor="let option of orderOptions(question.options, 'user_order' )">
                <div [@barWidthAnimation]="{value: '*', params: {width: '100%'}}"
                     class="bar"></div>
                <div class="vote-details">
                    <div [appTruncatedTooltip]="option.text">{{ option.text }}</div>
                    <div *ngIf="option.description" [appTruncatedTooltip]="option.description"
                         class="italic description">{{ option.description }}
                    </div>
                </div>
                <div class="percentage"> (<span [countUp]="option.votes_count"
                                                [duration]="500"> {{ option.votes_count }} </span>&nbsp;votes)
                </div>
            </div>
        </div>
    </ng-container>
    <div class="flex-row gap-10" *ngIf="!showResult">
        <div class="drag-container">
            <div cdkDropList="cdkDropList"
                 [cdkDropListData]="question.options"
                 class="drag-list"
                 (cdkDropListDropped)="drop($event, question)">
                @for (option of question.options; track option) {
                    <div class="drag-box" cdkDrag>
                        <div class="flex-col">
                            <p class="m-0">{{ option.text }}</p>
                            <p class="m-0" *ngIf="option.description">{{ option.description }}</p>
                        </div>
                        <div>
                            <mat-icon> drag_handle</mat-icon>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</ng-template>
<ng-template #listDragDrop let-question="question">
    <ng-container *ngIf="showResult">
        <ng-container *ngFor="let option of question.options">
            <div class="flex-col gap-10 mt-15" *ngIf="!option.hide_in_results">
                <p class="m-0">{{ option.text }}</p>
                <p class="m-0" *ngIf="option.description">{{ option.description }}</p>
                <div class="bar-container userVoted checked showResult"
                     *ngFor="let nestedOption of option.list_option_stats">
                    <div [@barWidthAnimation]="{value: '*', params: {width: showResult ? nestedOption.percentage+'%' : '0%'}}"
                         class="bar"></div>
                    <div class="vote-details">
                        <div [appTruncatedTooltip]="nestedOption.text">{{ nestedOption.text }}</div>
                        <div *ngIf="nestedOption.description" [appTruncatedTooltip]="nestedOption.description"
                             class="italic description">{{ nestedOption.description }}
                        </div>
                    </div>
                    <div class="percentage"> (<span [countUp]="nestedOption.votes_count"
                                                    [duration]="500"> {{ nestedOption.votes_count }} </span>&nbsp;votes)
                        <ng-container *ngIf="nestedOption.selected"> (Your Vote)</ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!showResult">
        <div class="flex-row gap-10 flex-mobile-col" [class.multipleLists]="question.options.length > 5">
            <div class="drag-container" *ngFor="let option of question.options">
                <p class="m-0">{{ option.text }}</p>
                <p class="m-0" *ngIf="option.description">{{ option.description }}</p>

                <div cdkDropList
                     [cdkDropListData]="option.nested_options" class="drag-list"
                     [cdkDropListConnectedTo]="connectedDropLists"
                     (cdkDropListDropped)="dropList($event)">
                    @for (nestedOption of option.nested_options; track nestedOption.id) {
                        <div class="drag-box" cdkDrag
                             [cdkDragData]="nestedOption">
                            <div class="flex-col">
                                <p class="m-0">{{ nestedOption.text }}</p>
                                <p class="m-0" *ngIf="nestedOption.description">{{ nestedOption.description }}</p>
                            </div>
                            <div>
                                <mat-icon> drag_handle</mat-icon>
                            </div>
                        </div>
                    }
                </div>
            </div>

        </div>
        <div class="flex-col">
            <ng-container *ngFor="let option of question.options">
                <small class="errorMsg"
                       *ngIf="option.slider_max != null && option.nested_options.length > option.slider_max">
                    Maximum items allowed for the list "{{ option.text }}" is {{ option.slider_max }} you currently
                    have {{ option.nested_options.length }}</small>
                <small class="errorMsg"
                       *ngIf="option.slider_min != null && option.nested_options.length < option.slider_min">
                    Minimum items allowed for the list "{{ option.text }}" is {{ option.slider_min }} you currently
                    have {{ option.nested_options.length }}</small>
            </ng-container>
        </div>
    </ng-container>
</ng-template>
